import { flex } from '@/styles/minix';
import styled from 'styled-components';
export const ResetForm = styled.div`
	.form-tip {
		margin-top: -10px;
		${flex('row', 'center', 'center')};

		span {
			color: rgba(222, 53, 10, 1);
			font-size: 14px;
			margin-left: 5px;
			font-weight: 300;
		}
	}
	.ant-form-item-label
		> label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
		content: '';
	}
`;
